import { createContext } from 'react';
import { HexomaticUserType } from '../types';

export const HexomaticUserContext = createContext({
  hexomaticUser: {} as HexomaticUserType,
  setHexomaticUser: (hexomaticUser: HexomaticUserType) => {},
});
